import { Briefcase, Heart, MessageSquare, Sparkles, Star, UserRound } from 'lucide-react';

/** The icon of each trait category (the quick-filter id); an unknown one degrades. */
export const TRAIT_CATEGORY_ICONS = Object.freeze({
  role_in_deal: UserRound,
  deal: Briefcase,
  interests: Star,
  communication: MessageSquare,
  personal: Heart,
});

export const iconForTraitCategory = (category) => TRAIT_CATEGORY_ICONS[category] ?? Sparkles;
